// VPNTutorials.js

import React from "react";
import "./VPNTutorials.css";

export default function VPNTutorials() {
  return (
    <section className="container PrivacyPolicySec">
      <div className="row">
        <div className="col">
          <div className="card PrivacyPolicyCard">
            <h3 className="card-header py-3">VPN Tutorials</h3>
            <div className="card-body">
              <ol className="px-5">
                <li className="py-2">
                  The first step after downloading 123MyVPN app is to launch it.
                  Once you open app, you will need to log in with the
                  credentials you created when signing up for our VPN service.
                </li>
                <li className="py-2">
                  Now it's time to create your account! Here's what to do:
                  <ol type="a">
                    <li className="py-2">
                      <b>Choose a Username : </b> In the first box, dream up a
                      username you would like to use. This will be your unique
                      identifier for 123MyVPN service.
                    </li>
                    <li className="py-2">
                      <b>Enter Your Email ID : </b> In the second box, type in
                      your valid email address. This is where we will send you
                      important information and might be used to verify your
                      account.
                    </li>
                    <li className="py-2">
                      <b>Provide a Strong Password : </b> A strong password is
                      long (ideally over 12 characters) and combines uppercase
                      and lowercase letters, numbers, and symbols. Don't use the
                      same password for everything!
                    </li>
                    <li className="py-2">
                      <b>Confirm Your Password : </b>Just to be safe, type your
                      password again in the fourth box. Make sure it matches
                      what you entered in the third box.
                    </li>
                    <li className="py-2">
                      <b>Confirm Your Sign Up! :</b> Once you've filled in all
                      the boxes, find the "Sign Up" button at the bottom and
                      click it. This will finalize your registration process.
                    </li>
                  </ol>
                </li>
                <li className="py-2">
                  After creating your account on 123MyVPN, you will redirected
                  to the payment page. You can choose subscription plan that
                  best suits your needs. We offer different packages with
                  varying features and durations. <br /> <br />
                  Look for options to pick your desired VPN package – we have
                  displayed different options with clear descriptions. You will
                  see "+" and "-" buttons to adjust the amount of data, you want
                  to consume. Once you have mad your selection, click on Select
                  Plan to lock your choice and proceed.
                </li>
                <li className="py-2">
                  Once you select your plan, you will be directed to the page
                  for choosing payment method. If you prefer to pay using
                  cryptocurrency as your payment method, select the option that
                  says "Crypto"
                </li>{" "}
                <li className="py-2">
                  Once you select your plan, you will be directed to the page
                  for choosing payment method. If you prefer to pay using
                  cryptocurrency as your payment method, select the option that
                  says "Crypto"
                </li>
                <li className="py-2">
                  Once you will choose "Cryptp" as payment method, you will see
                  2 cryptocurrencies Litecoin (LTC) and Bitcoin Cash (BCH) for
                  payment. These are both good choices because they don't come
                  with any transaction fee. Just pick the cryptocurrency you
                  prefer, then click "Submit" to continue with your payment.
                </li>
                <li className="py-2">
                  Head over to that specific cryptocurrency within your wallet
                  app. Once you are there, find the button labeled "Send". This
                  will initiate the process of sending your chosen
                  cryptocurrency for the purchase. For example, BCH has been
                  selected as the cryptocurrency here.
                </li>
                <li className="py-2">
                  After you choose cryptocurrency, you will see the amount on
                  the screen. This QR code contains all the information needed
                  to complete the transaction using your cryptocurrency wallet.
                  Now, find the QR code in your device's photo gallery (There
                  will be an icon with a red underline, click on that to select
                  the specific QR code image). Once you have selected it, you
                  can confirm the payment using the information encoded in the
                  QR code.
                </li>
                <li className="py-2">
                  Once you are in the gallery, find the specific QR code you
                  want to use for the payment. Select that QR code image, and
                  then you should be good to go to finalize your purchase.
                </li>
                <li className="py-2">
                  After scanning the QR code, you will see the payment details
                  appear on the screen. This will show the amount you are paying
                  and the recipient's address. Double-check everything looks
                  right, then click the "Next" button at the bottom of the page
                  to confirm the payment.
                </li>
                <li className="py-2">
                  Once you confirm the payment on this page, your purchase will
                  be complete. Head back to the VPN app and log in using your
                  email and password. The system will connect you to the VPN
                  after confirming the payment, which usually takes about two to
                  five minutes.<b> Be patient, and happy browsing!</b>
                </li>
                <li className="py-2">
                  To avoid service interruptions before your current package
                  expires, you can always purchase a new one in advance. Spot
                  the section highlighted with a red underline and that's where
                  you can purchase a new VPN package before your current one
                  runs out.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
